// extracted by mini-css-extract-plugin
export default {"wrap":"HorizontalCartList2_wrap__ymFXF","upAngle":"HorizontalCartList2_upAngle__k-75J","downAngle":"HorizontalCartList2_downAngle__AEMrA"};